module.exports = __webpack_public_path__ + "img/ordenarDiente.a809b2f5.svg";